import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import {
  NAMESPACE,
  TABS,
  LOCATION_TYPE_IDS,
  SUBSESSIONS_TAB
} from "./constants";

const indexedMap = R.addIndex(R.map);

const iniState = {
  loading: true,
  activeTab: TABS.BASIC_DETAILS,
  eventTags: [],
  languages: [],
  tracks: [],
  levels: [],
  formats: [],
  speakersList: [],
  sessionId: null,
  editing: false,
  returnToScene: null,
  isSubsession: false,
  parentSessionId: null,
  parentSessionData: {},
  convertSessionstoSubsessions: false,
  sessionsToConvert: [],
  selectedsessionsToConvert: [],
  sessionsToConvertIds: [],
  activeSubsessionsIndex: 0,
  sessionsToConvertCounter: 0,
  filter: "",
  pagination: {
    pageSize: 10,
    page: 1,
    offset: 0,
    limit: 10
  },
  linkSessionsToSubsessionsTab: SUBSESSIONS_TAB.SELECT_SESSIONS,
  data: {
    status: { color: "#FFE066", label: "Pending", value: "pending" },
    speakers: [],
    chairpersons: [],
    moderators: [],
    sponsors: [],
    exhibitors: [],
    languages: [],
    tracks: [],
    related_content: [],
    subsessions: [],
    location: null,
    location_stage_id: null,
    location_room_id: null,
    location_booth_id: null,
    location_external_url: null,
    session_location_type: null,
    session_submitter: null,
    //
    ceu_credits: null,
    title: "",
    starts_at: null,
    ends_at: null,
    description: "",
    venue_id: null,
    is_online_session: false,
    background_image_url: null,
    require_rsvp: false,
    rsvp_is_closed: false,
    rsvp_starts_at: null,
    rsvp_ends_at: null,
    rsvp_requires_approval: false,
    enable_capacity: null,
    capacity: null,
    enable_waitlist: false,
    waitlist_capacity: null,
    send_reminders: false,
    video_url: null,
    video_thumbnail_url: null,
    video_title: null,
    video_restrict_access: null,
    enable_question_queue: null,
    conference_url: null,
    conference_thumbnail_url: null,
    conference_title: null,
    conference_restrict_access: null,
    reveal_minutes_before: null,
    transcript_url: null,
    replay_url: null,
    play_recorded_video_content: null
  },
  showSessionModal: false,
  // language properties
  translatedValues: [],
  selectedTranslatedFieldId: null,
  languageModalIsOpen: false,

  // open in session in a new window
  hasUnSavedChangesModal: false,
  hasChanges: false,
  loadedAt: null
};

const model = createHandlers({
  iniState,
  reducers: {
    initSessionModal: R.identity,
    showBulkEditSpeakersModal: R.identity,
    saveAsDraft: R.identity,
    createSubsession: R.identity,
    nextPage: R.identity,
    previousPage: R.identity,
    uploadHeaderImg: R.identity,
    save: R.identity,
    openSession: R.identity,
    showContentModal: R.identity,
    goToParentSession: R.identity,
    goToSubsession: R.identity,
    onMenuSelectSubsession: R.identity,
    unlinkSubsession: R.identity,
    deleteSubsession: R.identity,
    searchSessions: R.identity,
    selectItem: R.identity,
    linkSessionAsSubsession: R.identity,
    handleChangeResultPerPage: R.identity,
    handleChangePages: R.identity,
    onSaveDone: R.identity,
    openFullPage: R.identity,
    onCancelUnsavedChanges: R.identity,
    onConfirmUnsavedChanges: R.identity,
    resetDataOnInit: () => ({
      ...iniState,
      showSessionModal: true,
      loading: true
    }),
    setInitialData: (
      { data, activeTab },
      {
        payload: {
          status,
          startsAt,
          endsAt,
          roomId,
          sessionId,
          sessionData,
          parentSessionId,
          parentSessionData,
          editing,
          iniScene,
          returnToScene,
          isSubsession,
          convertSessionstoSubsessions
        }
      }
    ) => {
      return {
        loadedAt: new Date(),
        hasUnSavedChages: false,
        convertSessionstoSubsessions,
        isSubsession,
        activeTab: R.propOr(
          activeTab,
          iniScene
        )({
          messages: TABS.MESSAGES,
          activity: TABS.ACTIVITY,
          content: TABS.CONTENT
        }),
        editing,
        sessionId,
        returnToScene,
        parentSessionId,
        parentSessionData: parentSessionData ? parentSessionData : {},
        data:
          parentSessionId && !sessionId
            ? {
                starts_at: parentSessionData.starts_at,
                ends_at: parentSessionData.ends_at
              }
            : sessionData
            ? {
                ...sessionData,
                status: sessionData.status
                  ? {
                      value: sessionData.custom_status_id || sessionData.status,
                      label: sessionData.status_label,
                      color: sessionData.status_color
                    }
                  : null,
                tags: R.map(t => ({
                  value: t.id,
                  label: t.name
                }))(sessionData.tags),
                language: sessionData.language
                  ? {
                      value: sessionData.language.id,
                      label: sessionData.language.name
                    }
                  : null,
                track: sessionData.track
                  ? {
                      value: sessionData.track.id,
                      label: sessionData.track.name
                    }
                  : null,
                level: sessionData.level
                  ? {
                      value: sessionData.level.id,
                      label: sessionData.level.name
                    }
                  : null,
                format: sessionData.format
                  ? {
                      value: sessionData.format.id,
                      label: sessionData.format.name
                    }
                  : null,
                speakers: R.map(t => ({
                  id: t.id,
                  value: t.id,
                  name: t.name,
                  label: `${t.name} ${t.id}`,
                  isSpeakerPublic: t?.is_public ?? true //default to true
                }))(sessionData.speakers),
                chairpersons: R.map(t => ({
                  value: t.id,
                  label: t.name
                }))(sessionData.chairpersons),
                moderators: R.map(t => ({
                  value: t.id,
                  label: t.name
                }))(sessionData.moderators),
                sponsors: R.map(t => ({
                  value: t.id,
                  label: t.name
                }))(sessionData.sponsors),
                exhibitors: R.map(t => ({
                  value: t.id,
                  label: t.name
                }))(sessionData.exhibitors),
                session_submitter: sessionData?.owner
                  ? {
                      value: sessionData.owner.id,
                      label: sessionData.owner.name
                    }
                  : null,
                related_content: sessionData.related_content,
                session_location_type: sessionData.session_location_type
                  ? {
                      value: sessionData.session_location_type
                    }
                  : null
              }
            : {
                ...data,
                status: status || data.status,
                starts_at: startsAt || data.starts_at,
                ends_at: endsAt || data.ends_at,
                location: roomId ? LOCATION_TYPE_IDS.ROOM : data.location,
                location_room_id: roomId || data.location_room_id
              }
      };
    },
    reorderContent: (state, { payload: content }) => ({
      data: {
        ...state.data,
        related_content: indexedMap((c, order) => ({ ...c, order }), content)
      }
    }),
    addContent: (state, { payload: content }) => {
      const exists = state.data.related_content.some(c => c.id === content.id);

      if (exists) {
        return {};
      }

      return {
        data: {
          ...state.data,
          related_content: [...state.data.related_content, content]
        }
      };
    },
    addContentVideo: (state, { payload: content }) => ({
      data: {
        ...state.data,
        play_recorded_video_content: content
      }
    }),
    removeContentVideo: state => ({
      data: {
        ...state.data,
        play_recorded_video_content: null
      }
    }),
    removeContent: (state, { payload: contentId }) => ({
      data: {
        ...state.data,
        related_content: state.data.related_content.filter(
          c => c.id !== contentId
        )
      }
    }),
    backSelectedSubssesionsButton: state => ({
      ...state,
      convertSessionstoSubsessions: false,
      filter: "",
      selectedsessionsToConvert: [],
      sessionsToConvertIds: [],
      linkSessionsToSubsessionsTab: SUBSESSIONS_TAB.SELECT_SESSIONS
    }),
    updateField: (state, { payload: { field, value } }) => ({
      data: R.assoc(field, value, state.data)
    }),
    toggleOnlineSession: state => ({
      data: R.assoc(
        "is_online_session",
        R.not(R.pathOr(false, ["data", "is_online_session"], state)),
        state.data
      )
    }),
    toggleRequireRsvp: state => ({
      data: R.assoc(
        "require_rsvp",
        R.not(R.pathOr(false, ["data", "require_rsvp"], state)),
        state.data
      )
    }),
    toggleRemindAttendees: state => ({
      data: R.assoc(
        "send_reminders",
        R.not(R.pathOr(false, ["data", "send_reminders"], state)),
        state.data
      )
    }),
    handleConvertSessionstoSubsessions: state => ({
      convertSessionstoSubsessions: !state.convertSessionstoSubsessions
    }),
    resetData: R.always(iniState),
    updateTranslatedValue: (
      state,
      { payload: { fieldInternalName, language, isDefault, value } }
    ) => {
      let hasChanges = false;

      if (isDefault) {
        return {
          hasChanges: hasChanges ? true : state.hasChanges,
          data: R.assoc(fieldInternalName, value, state.data)
        };
      } else {
        const updatedValues = state.translatedValues.map(v => {
          if (
            v.field_internal_name === fieldInternalName &&
            v.language === language
          ) {
            const val1 =
              v.translated_value && v.translated_value.length
                ? v.translated_value
                : "";
            const val2 = value && value.length ? value : "";
            if (val1 !== val2) {
              hasChanges = true;
            }
            return {
              ...v,
              translated_value: value
            };
          }
          return v;
        });

        return {
          translatedValues: updatedValues
        };
      }
    },
    setSpeakerIsPublicInStore: (
      state,
      { payload: { id, isSpeakerPublic } }
    ) => ({
      data: R.assoc(
        "speakers",
        R.map(s => (s.id === id ? { ...s, isSpeakerPublic } : s))(
          state.data.speakers
        ),
        state.data
      )
    })
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
